import { render, staticRenderFns } from "./DictionaryModal.vue?vue&type=template&id=3bafce82&"
import script from "./DictionaryModal.vue?vue&type=script&lang=js&"
export * from "./DictionaryModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports